// Facebook Icon:
// Simple Facebook icon.

// Core
import React from 'react'

const Facebook = () => (
  <svg width="20" height="20" viewBox="0 0 20 20">
    <path d="M1.10359 0.3125C0.49375 0.3125 0 0.806094 0 1.41609V19.2091C0 19.8186 0.493594 20.3127 1.10359 20.3127H10.6838V12.5684H8.07625V9.55078H10.6838V7.32422C10.6838 4.74094 12.2611 3.335 14.5656 3.335C15.6694 3.335 16.6181 3.41547 16.8947 3.45219V6.15234H15.298C14.0447 6.15234 13.7989 6.74812 13.7989 7.62203V9.55078H16.7872L16.4014 12.5684H13.7989V20.3127H18.8966C19.5061 20.3127 20.0002 19.8189 20.0002 19.2091V1.41609C20.0002 0.806406 19.5061 0.3125 18.8966 0.3125H1.10359V0.3125Z" />
  </svg>
)

export default Facebook
